import React, { lazy, Suspense } from 'react';
import { withRouter } from 'react-router-dom';
import './libs/font-awesome/css/font-awesome.min.css';
import './stylesheets/style.css';
import './stylesheets/style.scss';
import Notifications from 'react-notify-toast';
import SuspenseErrorBoundaryWrapper from 'common/SuspenseErrorBoundaryWrapper';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import AuthRoute from './auth/auth.route.jsx';
import './stylesheets/zentrades-theme.css';

import { isMixPanelTrackingEnabled, trackingUtils } from 'utils/mixpanelUtils';
import './i18n/config';
// TODO change value based on api response
const globalContextValue = {
  isPriceBookEnabled: false
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (isMixPanelTrackingEnabled()) {
      initializeMixPanel();
    }
    if (process.env.NODE_ENV !== 'development') {
      initializeDataDog();
    }
  }

  render() {
    return (
      <div style={{ height: '100%' }}>
        <SuspenseErrorBoundaryWrapper>
          <AuthRoute />
        </SuspenseErrorBoundaryWrapper>
        <Notifications />
      </div>
    );
  }
}

const initializeDataDog = () => {
  datadogLogs.init({
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    env: process.env.REACT_APP_DATADOG_ENV
  });
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'pwa',
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    env: process.env.REACT_APP_DATADOG_ENV
  });
};

const initializeMixPanel = () => {
  trackingUtils.initializeTracking();
  trackingUtils.identify();
  trackingUtils.setProperty();
};

export default withRouter(App);
